import { Component, Input, Output, OnInit, EventEmitter } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Project } from "../../interfaces/project";

@Component({
  selector: "app-annotationtype-display",
  templateUrl: "./annotationtype-display.component.html",
  styleUrls: ["./annotationtype-display.component.scss"],
})
export class AnnotationtypeDisplayComponent implements OnInit {
  readonly env: any = environment;

  @Input() project: Project;
  @Input() type: any;
  @Input() index: number;
  @Input() alt: boolean = false;
  @Input() canDelete: boolean = true;

  @Output()
  changeAnnotationTypeClicked: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  deleteAnnotationTypeClicked: EventEmitter<number> = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  changeAnnotationType() {
    this.changeAnnotationTypeClicked.emit(this.index);
  }

  deleteAnnotationType() {
    this.deleteAnnotationTypeClicked.emit(this.index);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/annotationtype-display/annotationtype-display.component.ts